import React, { useEffect } from 'react'
import injectSheet from 'react-jss'
import styles from './assessment.styles'
import Scene from './scene/scene.container'

const Assessment = ({ classes, onMount, id }) => {
  useEffect(() => {
    onMount(id)
  }, [onMount, id])
  return (
    <div className={classes.container}>
      <Scene />
    </div>
  )
}

export default injectSheet(styles)(Assessment)
